exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".anno{width:400px}.anno-inner{border:1px solid #000;border-radius:4px;box-shadow:3px 3px 3px rgba(0,0,0,.39)!important}.complete-page-tag{top:35%!important}.anno-btn-low-importance{border-style:solid!important;border-width:1px!important}.btn-disabled{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/tutorial.css
// module id = 1990
// module chunks = 0